module.exports = __webpack_public_path__ + "static/Danzza-Bold-5d5584283daf4f6b4b093e9a99cc82aa.woff2";